import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { IMenuLink } from "../types";

export const backToPortal: IMenuLink = {
  name: "Back To Portal",
  href: "/",
  text: "Back To Portal",
  icon: ArrowBackIcon,
  type: "link",
  options: { label: "Back To Portal", menuDividerAbove: true },
};

export const externalUserlinks: Array<IMenuLink> = [
  {
    name: "statements",
    resourceMatch: /statements/,
    type: "resourcelink",
  },
  {
    name: "users",
    type: "resourcelink",
    resourceMatch: /org.*users/,
    permission: /ACS\.ORG_EXTERNAL_ADMIN/,
  },
  {
    name: "contacts",
    type: "resourcelink",
    resourceMatch: /contacts/,
  },
  backToPortal,
];

export const internalUserlinks: Array<IMenuLink> = [
  {
    name: "statements",
    resourceMatch: /statements/,
    type: "resourcelink",
  },
  {
    name: "users",
    resourceMatch: /users/,
    type: "resourcelink",
    permission: /ACS\.INTERNAL_ADMIN/,
  },
  backToPortal,
];
